import axios from "axios";

export default {
    validate(token) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "public/validate/" + token,
        });
    },
};
